import i18n from 'i18next'
import compose from 'ramda/src/compose'
import head from 'ramda/src/head'
import split from 'ramda/src/split'

/**
 * @typedef Lang
 * @type {'en' | 'zh' | 'ja' | 'cs' | 'it' | 'es' | 'ar' | 'vi' | 'th' | 'ko'}
 */

export const langStorage = {
  allow: typeof localStorage === 'object',
  /**
   * @returns {Lang}
   */
  get () {
    return (this.allow && localStorage.getItem('lang')) || 'en'
  },
  getShort () {
    return compose(
      head,
      split('-')
    )(langStorage.get())
  },
  /**
   * @param {Lang} lang
   */
  save (lang) {
    return this.allow ? localStorage.setItem('lang', lang) : undefined
  }, /**
   * @param {Lang} lang
   */
  callback (lang) {
    return error => {
      if (error) {
        console.log('Error when load language', error)
      }
      this.save(lang)
    }
  },
  empty () {
    localStorage.removeItem('lang')
  }
}

export const languages = [
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'ja',
    name: '日本語'
  },
  {
    code: 'zh',
    name: '中文'
  },
  {
    code: 'ko',
    name: '한국어'
  },
  {
    code: 'cs',
    name: 'Český'
  },
  {
    code: 'es',
    name: 'Espanol'
  },
  {
    code: 'it',
    name: 'Italiano'
  },
  {
    code: 'ar',
    name: 'عربى'
  },
  {
    code: 'vi',
    name: 'Tiếng Việt'
  },
  {
    code: 'th',
    name: 'ไทย'
  }
]

const isLangExcluded = (lang, excludedLang) => excludedLang.indexOf(lang) !== -1
const isLangExist = (lang) => Boolean(languages.find(language => language.code === lang))

export const setDefaultLang = (excludedLang = [], urlLang) => {
  if (urlLang && !isLangExcluded(urlLang, excludedLang) && isLangExist(urlLang)) {
    i18n.changeLanguage(urlLang, langStorage.callback(urlLang))
    return
  }

  if (localStorage.getItem('lang')) {
    const lsLang = langStorage.get()
    if (!isLangExcluded(lsLang, excludedLang) && isLangExist(lsLang)) {
      i18n.changeLanguage(lsLang)
      return
    } else {
      langStorage.empty()
    }
  }

  let language
  const browserLang = navigator.language || navigator.userLanguage
  languages.forEach(({ code: lang }) => {
    if (lang.includes(browserLang)) {
      language = lang
    }
  })
  if (language && !isLangExcluded(language, excludedLang)) {
    langStorage.save(language)
    i18n.changeLanguage(language)
  }
}

export const getUrlLang = url => {
  let curUrl = ''
  const lang = langStorage.getShort()
  if (lang && url[lang]) {
    curUrl = url[lang]
  } else if (url.en) {
    curUrl = url.en
  }
  return curUrl
}

export const tByPlatform = (targetPlatform, message) => {
  const isExist = i18n.exists(`${targetPlatform}.${message}`)
  return isExist ? `${targetPlatform}.${message}` : message
}

export const getCurrentLangName = () => {
  return languages.find(item => item.code === i18n.language).name
}
